var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.7498V14.2498C13.3333 17.1665 12.1666 18.3332 9.24996 18.3332H5.74996C2.83329 18.3332 1.66663 17.1665 1.66663 14.2498V10.7498C1.66663 7.83317 2.83329 6.6665 5.74996 6.6665H9.24996C12.1666 6.6665 13.3333 7.83317 13.3333 10.7498Z",
    stroke: "#9135E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.74984V9.24984C18.3333 12.1665 17.1666 13.3332 14.25 13.3332H13.3333V10.7498C13.3333 7.83317 12.1666 6.6665 9.24996 6.6665H6.66663V5.74984C6.66663 2.83317 7.83329 1.6665 10.75 1.6665H14.25C17.1666 1.6665 18.3333 2.83317 18.3333 5.74984Z",
    stroke: "#9135E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.8037485efe62db034b3def2c995a7fd2.svg";
export { ForwardRef as ReactComponent };